import MoreIcon from '@/assets/images/common/svg/more.svg?react';
import GroupHeaderEditModal from '../group-header-edit-modal';
// import styles from '../../index.module.scss';
import classes from './index.module.scss';
import type { GroupHeaderProps } from './interface';

export default function GroupHeader({
  chat,
  isGroupOwner,
  isGroupManager,
  normalMemberList,
  insertSettings,
  updateGroups,
}: GroupHeaderProps) {
  const [groupHeaderEditModalOpen, setGroupHeaderEditModalOpen] = useState(false);

  const canEdit = useMemo(() => {
    return isGroupOwner || isGroupManager;
  }, [isGroupOwner, isGroupManager]);

  return (
    <>
      <div
        className={cls(classes.groupHeader, {
          [classes.groupHeaderEdit]: canEdit,
        })}
        onClick={() => {
          if (canEdit) {
            setGroupHeaderEditModalOpen(true);
          }
        }}
      >
        <img src={chat.avatar} className={classes.avatar} />
        <div className={classes.info}>
          <div className={classes.name}>{chat.name}</div>
          {normalMemberList?.length > 0 && (
            <div className={classes.number}>
              Group · {normalMemberList?.length} members
            </div>
          )}
        </div>
        {canEdit && <MoreIcon />}
      </div>
      <GroupHeaderEditModal
        open={groupHeaderEditModalOpen}
        value={chat.name}
        chat={chat}
        onCancel={() => setGroupHeaderEditModalOpen(false)}
        insertSettings={insertSettings}
        updateGroups={updateGroups}
      />
    </>
  );
}
